import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import GeneralInspectionReportRoute from './route';
import {
    Select,
    Button,
    Divider,
    Table,
    Input,
    Spin,
    PageHeader,
    Tooltip,
    Icon,
    Space,
} from 'udesk-ui';
import UdeskDatePicker from 'Component/common/udesk-date-picker';
import AgentGroupAndAgentSelect from 'src/components/common/AgentGroupAndAgentSelect';
import _isEmpty from 'lodash-es/isEmpty';
import _size from 'lodash-es/size';
import ReactEcharts from 'udesk-react/src/components/react-echarts/base';
import ClassNames from 'classnames';
import { PadOne } from './components';
import './style.scss';

export default class GeneralInspectionReportTemplate extends GeneralInspectionReportRoute {
    render() {
        let { actions, locales } = this;
        let { TextArea } = Input;
        let { callList, echarsType } = this.privates;
        let {
            radioValue,
            loading,
            textAreaText,
            echarsTypeField,
            effectDataListEcharts,
            agentTableRef,
            agentDataList,
            agentColumns,
            effectListData,
            lineDataList,
            columns,
            effectTableData,
            statAt,
            taskDataList,
            taskId,
            agentGroups,
            agentDepartments,
            agents,
            proposalData,
            callListData,
            surveyListData,
            ticketListData,
            mallListData,
            dialogListData,
        } = this.privates;
        let { Option } = Select;
        let list = Udesk.business.report.getChartDataFix(this, lineDataList);
        let effectList = Udesk.business.report.getChartDataFix(this, effectDataListEcharts);
        const company = Udesk.data.init.company;

        return (
            <div className="udesk-qa-web-page">
                <PageHeader
                    className="udesk-qa-web-page-header"
                    title={this.locales.components.pages.dataAnalysis.generalInspecitionReport}
                />
                <div className="udesk-qa-web-page-body">
                    <div
                        className="udesk-qa-web-page-body-root general-inspection-report-page"
                        style={{ backgroundColor: 'transparent' }}
                    >
                        <div className="general-inspection-report-page-filter">
                            <span>
                                {locales.fix.datePickerSelect}：{' '}
                                <UdeskDatePicker onChange={actions.timeChange} value={statAt} />
                            </span>

                            <span style={{ marginLeft: '10px' }}>
                                {locales.fix.callSelect}：
                                <Select
                                    disabled={
                                        !(
                                            company.enabledCallInspect !== 0 &&
                                            company.enabledImInspect !== 0
                                        )
                                    }
                                    options={callList}
                                    value={radioValue}
                                    onChange={actions.radioGroup}
                                    style={{ width: '130px' }}
                                />
                            </span>

                            <span style={{ marginLeft: '10px' }}>
                                {locales.fix.taskSelect}：
                                <Select
                                    style={{ width: '130px' }}
                                    value={taskId}
                                    onChange={actions.taskFieldChange}
                                >
                                    {!_isEmpty(taskDataList) &&
                                        taskDataList.map((item) => {
                                            return (
                                                <Option
                                                    value={item.qa_inspection__task_id}
                                                    title={item.qa_inspection__task_name}
                                                >
                                                    {item.qa_inspection__task_name}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            </span>

                            <span style={{ marginLeft: '10px' }}>
                                {`${
                                    /* 客服 */ UdeskLocales['current'].pages.dataAnalysis
                                        .generalInspectionReport.template.customerService
                                }`}
                                ：
                                <AgentGroupAndAgentSelect
                                    value={{
                                        agentGroups,
                                        agentDepartments,
                                        agents,
                                    }}
                                    onChange={actions.agentGroupAndAgentChange}
                                />
                            </span>

                            <span style={{ marginLeft: '15px' }}>
                                <Button type="primary" onClick={actions.dataSave}>
                                    {locales.fix.genReport}
                                </Button>
                                <Button style={{ marginLeft: '5px' }} onClick={actions.dataCancel}>
                                    {locales.labels.reset}
                                </Button>
                                <Button style={{ marginLeft: '5px' }} onClick={actions.dataExport}>
                                    {locales.labels.export}
                                </Button>
                            </span>
                        </div>

                        <Spin spinning={loading}>
                            <div className="general-inspection-report-page-data">
                                <h2 className="general-list-title">
                                    <Space>
                                        {locales.fix.dataSource}
                                        <Tooltip
                                            title={
                                                <div style={{ whiteSpace: 'pre-wrap' }}>
                                                    {
                                                        this.locales.components.pages.dataAnalysis
                                                            .generalInspecitionReportTip
                                                    }
                                                </div>
                                            }
                                        >
                                            <Icon
                                                type="QuestionCircleOutlined"
                                                antdIcon={true}
                                            ></Icon>
                                        </Tooltip>
                                    </Space>
                                </h2>
                                <div className="general-inspection-report-page-data-list">
                                    {!_isEmpty(callListData) && (
                                        <>
                                            <PadOne
                                                title={locales.fix.callsTotal}
                                                data={callListData}
                                                inspectDataSource={1}
                                            />

                                            {radioValue === '-1' && <Divider />}
                                        </>
                                    )}

                                    {!_isEmpty(dialogListData) && (
                                        <>
                                            <PadOne
                                                title={locales.fix.totalConversation}
                                                data={dialogListData}
                                                inspectDataSource={2}
                                            />

                                            {radioValue === '-1' && <Divider />}
                                        </>
                                    )}

                                    {!_isEmpty(surveyListData) && (
                                        <>
                                            <PadOne
                                                title={
                                                    /* 问卷总量 */ UdeskLocales['current'].pages
                                                        .dataAnalysis.generalInspectionReport
                                                        .template.totalQuestionnaire
                                                }
                                                data={surveyListData}
                                                inspectDataSource={20}
                                            />
                                            {radioValue === '-1' && <Divider />}
                                        </>
                                    )}

                                    {!_isEmpty(ticketListData) && (
                                        <>
                                            <PadOne
                                                title={
                                                    /* 工单总量 */ UdeskLocales['current'].pages
                                                        .dataAnalysis.generalInspectionReport
                                                        .template.totalWorkOrder
                                                }
                                                data={ticketListData}
                                                inspectDataSource={10}
                                            />
                                            {radioValue === '-1' && <Divider />}
                                        </>
                                    )}

                                    {!_isEmpty(mallListData) && (
                                        <>
                                            <PadOne
                                                title={
                                                    /* 电商会话总量 */ UdeskLocales['current'].pages
                                                        .dataAnalysis.generalInspectionReport
                                                        .template.totalEcommerceSessions
                                                }
                                                data={mallListData}
                                                inspectDataSource={8}
                                            />
                                        </>
                                    )}
                                </div>

                                {!_isEmpty(list.items) && !_isEmpty(list.columns) && (
                                    <div className="general-inspection-report-page-data-line">
                                        <div className="general-inspection-echarsType">
                                            {!_isEmpty(echarsType) &&
                                                echarsType.map((item) => {
                                                    return (
                                                        <div
                                                            className={ClassNames({
                                                                'general-inspection-echarsType-active':
                                                                    echarsTypeField === item.key,
                                                            })}
                                                            onClick={actions.echarsTypeChange.params(
                                                                item.key
                                                            )}
                                                        >
                                                            {item.name}
                                                        </div>
                                                    );
                                                })}
                                        </div>

                                        <ReactEcharts
                                            type="line"
                                            xLabelField="xLabel"
                                            height={350}
                                            showTooltips={true}
                                            finalizeChartOptions={(option) => {
                                                option.legend = {
                                                    ...option.legend,
                                                    left: 'center',
                                                };
                                                option.tooltip = {
                                                    trigger: 'axis',
                                                    formatter: (params) => {
                                                        let str = '';
                                                        str += params[0].data.name + '<br />';
                                                        params.forEach((item) => {
                                                            if (item.seriesIndex === 2) {
                                                                if (
                                                                    item.value.indexOf('%') === -1
                                                                ) {
                                                                    item.value = item.value + '%';
                                                                }
                                                            }
                                                            str +=
                                                                item.seriesName +
                                                                '：' +
                                                                item.value +
                                                                '<br />';
                                                        });
                                                        return str;
                                                    },
                                                };
                                                if (option.series.length > 0) {
                                                    option.series[0].type = 'bar';
                                                    if (option.series.length > 1) {
                                                        option.series[0].stack = locales.fix.data;
                                                        option.series[1].stack = locales.fix.data;
                                                        option.series[1].type = 'bar';
                                                    }
                                                    if (option.series.length > 2) {
                                                        option.series[2].data.forEach((item) => {
                                                            item.value = (item.value * 100).toFixed(
                                                                2
                                                            );
                                                        });
                                                    }
                                                }
                                                return option;
                                            }}
                                            records={list.items}
                                            seriesColumns={list.columns}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="general-inspection-report-page-effect">
                                <h2 className="general-list-title">
                                    {locales.fix.inspectionEffect}
                                </h2>
                                <div className="general-inspection-report-page-effect-list">
                                    {!_isEmpty(effectListData) && (
                                        <div className="general-inspection-report-page-effect-list-info">
                                            <div className="general-inpsection-report-page-effect-list-info-field">
                                                <h2>{locales.fix.allTotal}</h2>
                                                <p className="field-top-p-style1">
                                                    {locales.fix.artificialSampling}
                                                </p>
                                                <div class="field-big-effect-sp">
                                                    {effectListData.qa_inspection_effects__check_count >
                                                    9999
                                                        ? `${(
                                                              effectListData.qa_inspection_effects__check_count /
                                                              1000
                                                          ).toFixed(1)}`
                                                        : `${
                                                              effectListData.qa_inspection_effects__check_count ??
                                                              0
                                                          }`}
                                                </div>
                                            </div>
                                            <div className="general-inpsection-report-page-effect-list-info-field">
                                                <p className="field-top-p-style2">
                                                    {locales.fix.manualInspection}
                                                </p>
                                                <div class="field-big-effect-rew">
                                                    {effectListData.qa_inspection_effects__review_approval_count >
                                                    9999
                                                        ? `${(
                                                              effectListData.qa_inspection_effects__review_approval_count /
                                                              1000
                                                          ).toFixed(2)}K`
                                                        : `${
                                                              effectListData.qa_inspection_effects__review_approval_count ??
                                                              0
                                                          }`}
                                                </div>
                                            </div>
                                            <div className="general-inpsection-report-page-effect-list-info-field">
                                                <h2>{locales.fix.approvalAmountAndRate}</h2>
                                                <p className="field-top-p-style1">
                                                    {locales.fix.artificialSampling}
                                                </p>
                                                <div class="field-small-effect">
                                                    {effectListData.qa_inspection_effects__extraction_count >
                                                    9999
                                                        ? `${(
                                                              effectListData.qa_inspection_effects__extraction_count /
                                                              1000
                                                          ).toFixed(1)}`
                                                        : `${
                                                              effectListData.qa_inspection_effects__extraction_count ??
                                                              0
                                                          }`}
                                                </div>
                                                <p>
                                                    {locales.fix.percentage}：
                                                    <span>
                                                        {effectListData.qa_inspection_effects__extraction_rate ??
                                                            0}
                                                    </span>
                                                </p>
                                            </div>
                                            <div className="general-inpsection-report-page-effect-list-info-field">
                                                <p className="field-top-p-style2">
                                                    {locales.fix.artificialReview}
                                                </p>
                                                <div class="field-small-effect">
                                                    {effectListData.qa_inspection_effects__review_count >
                                                    9999
                                                        ? `${(
                                                              effectListData.qa_inspection_effects__review_count /
                                                              1000
                                                          ).toFixed(1)}`
                                                        : `${
                                                              effectListData.qa_inspection_effects__review_count ??
                                                              0
                                                          }`}
                                                </div>
                                                <p>
                                                    {locales.fix.percentage}：
                                                    <span>
                                                        {effectListData.qa_inspection_effects__review_approval_rate ??
                                                            0}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                    {!_isEmpty(effectList.items) && !_isEmpty(effectList.columns) && (
                                        <div className="general-inspection-report-page-effect-line">
                                            <ReactEcharts
                                                type="line"
                                                xLabelField="xLabel"
                                                height={320}
                                                showTooltips={true}
                                                finalizeChartOptions={(option) => {
                                                    option.legend = {
                                                        ...option.legend,
                                                        left: 'center',
                                                    };

                                                    option.tooltip = {
                                                        trigger: 'axis',
                                                        formatter: (params) => {
                                                            let str = '';
                                                            str += params[0].data.name + '<br />';
                                                            params.forEach((item) => {
                                                                if (
                                                                    item.value.indexOf('%') === -1
                                                                ) {
                                                                    item.value = item.value + '%';
                                                                }
                                                                str +=
                                                                    item.seriesName +
                                                                    '：' +
                                                                    item.value +
                                                                    '<br />';
                                                            });
                                                            return str;
                                                        },
                                                    };
                                                    option.series.forEach((item) => {
                                                        item.data.forEach((items) => {
                                                            items.value = (
                                                                items.value * 100
                                                            ).toFixed(2);
                                                        });
                                                    });
                                                    return option;
                                                }}
                                                records={effectList.items}
                                                seriesColumns={effectList.columns}
                                            />
                                        </div>
                                    )}
                                    <div className="general-inspection-report-page-effect-table">
                                        <Table
                                            columns={columns}
                                            dataSource={effectTableData}
                                            pagination={false}
                                            scroll={{ y: 406 }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="general-inspection-report-page-agent">
                                <h2 className="general-list-title">{locales.fix.customerScore}</h2>
                                <div className="general-inspection-report-page-agent-list">
                                    <div
                                        id="agent-table"
                                        style={{
                                            width: `${
                                                (document.documentElement.clientWidth - 60) * 0.83 -
                                                30 -
                                                160 -
                                                20
                                            }px`,
                                        }}
                                        ref={agentTableRef}
                                        className="general-inspection-report-page-agent-list-table"
                                    >
                                        <Table
                                            columns={agentColumns}
                                            dataSource={agentDataList}
                                            pagination={false}
                                            scroll={{ x: _size(agentColumns) * 200 + 100, y: 406 }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="general-inspection-report-page-proposal">
                                <h2 className="general-list-title">
                                    {locales.fix.inspectionRecommendations}
                                </h2>
                                <div className="general-inspection-report-page-proposal-list">
                                    <div className="general-inspection-report-page-proposal-list-textarea">
                                        <TextArea
                                            autosize={{ minRows: 7, maxRows: 10 }}
                                            allowClear={true}
                                            value={textAreaText}
                                            placeholder={locales.fix.advicePlaceHolder}
                                            onChange={actions.textAreaChange}
                                        />
                                        <div className="proposal-list-button">
                                            <Button type="primary" onClick={actions.textAreaSave}>
                                                {locales.fix.saveDraft}
                                            </Button>
                                            <Button
                                                style={{ marginLeft: '5px' }}
                                                onClick={actions.textAreaCancel}
                                            >
                                                {locales.labels.reset}
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="general-inspection-report-page-proposal-list-history">
                                        <div className="general-inspection-report-page-proposal-list-history-list">
                                            <div className="general-inspection-report-page-proposal-list-history-list-title">
                                                {locales.fix.historicalAdvice}（
                                                {_size(proposalData)}）
                                            </div>
                                            <div className="general-inspection-report-page-proposal-list-history-list-info">
                                                {!_isEmpty(proposalData) &&
                                                    proposalData.map((item) => {
                                                        return (
                                                            <div className="proposal-list-history-list-info-field">
                                                                <div>
                                                                    <span className="field-title">
                                                                        {item.name}
                                                                    </span>
                                                                    <span className="field-time">
                                                                        {item.createTime}
                                                                    </span>
                                                                </div>
                                                                {!_isEmpty(item.inspectionRemark) &&
                                                                    item.inspectionRemark.map(
                                                                        (items) => {
                                                                            return (
                                                                                <div className="field-info-list">
                                                                                    <p className="field-info">
                                                                                        -{items}
                                                                                    </p>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    )}
                                                                <Divider />
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Spin>
                    </div>
                </div>
            </div>
        );
    }
}
